import {
    AnnounceInputs,
    IProperty,
    ReviewInputs,
    IAnnounce
} from "../../../utils/AnnounceInterfaces";
import Api from "../../../https/Api";

export class AnnouncesService { 
    private api: Api;
    constructor() {
        this.api = new Api();
    }

    //get
    async getLocationTypes() {
        return this.api.get("locationTypes");
    }

    async getAllPropertyTypes() {
        return this.api.get("propertiesTypes");
    }

    async getAnnounceById(id: string) {
        return this.api.simpleGet("announces/getadm", id);
    }

    async getListAnnounces(filter: any, page: number = 1, limit: number = 10) {
        return this.api.simpleGetWithFilter(`announces`, filter);
    }

    async indisponible(anounceID: string, newStete: Date) {
        const params = {
            anounceID,
            state: newStete,
        };
        ///announces/updateAmbassador
        return this.api.post("announces/indisponible", params);
    }

    async disponible(anounceID: string, newStete: Date) {
        const params = {
            anounceID,
            state: newStete,
        };
        ///announces/updateAmbassador
        return this.api.post("announces/disponible", params);
    }

    async getListProperties(filter: any) {
        return this.api.simpleGetWithFilter(`properties`, filter);
    }

    async getCommissionFeeByCountryAndCityId(
        countryName: string,
        cityName: string
    ) {
        return this.api.simpleGetWithTwoParams(
            "settings/commissions-fees-country-city",
            countryName,
            cityName
        );
    }

    async getSpecialFeeByPropertyType(propertyType: string) {
        return this.api.simpleGet(
            "settings/specials-fees/property-type",
            propertyType
        );
    }


    // Increment the view count for a specific announce by its ID
    async incrementViewsById(id: string) {
        return this.api.post(`announces/${id}/increment-view-count`, {});
    }

    //post
    async saveAnnounce(announce: AnnounceInputs) {
        return this.api.post("announces/create", announce);
    }

    async updatePropertyById(property: Partial<IProperty>) {
        if (property._id)
            return this.api.postById(
                "properties/update",
                property._id,
                property
            );
    }

    //delete
    async deleteAnnounce(id: string) {
        return this.api.simpleDeleteById(`announces/delete`, id);
    }

    async deletesAnnounce(ids: string[]) {
        const param = {
            ids: ids,
        };
        return this.api.deleteMany("announces/deleteMany", param);
    }

    async saveReview(review: ReviewInputs) {
        return this.api.post(`reviews/Create`, review);
    }

    
    async saveReviewWithFiles(formData: FormData) {
        return this.api.post(`reviews/Create`, formData, false, true);
        // false = not cancelable
        // true = is FormData
    }

    async getReviewsByAnnounceID(id: string) {
        return this.api.simpleGet("reviews/byAnnounce", id);
    }
    async favorisAnnonce(id: string, idAnnonce: string) {
        return this.api.postID(
            `users/add-announce-to-bookmarks`,
            id,
            idAnnonce
        );
    }
    async getusersById(id: string) {
        return this.api.simpleGet("users/get", id as string);
    }

    async checkUserBooking(idUser: string, idAnnounce: string) {
        return this.api.simpleGetWithTwoParams(
            //"reviews/user/check",
            "reviews/user/bookings",
            idUser,
            idAnnounce
        );
    }

      // Fetch all reviews, including hidden ones (for admins)
  async fetchAllReviews(announceId: string) {
    //console.log("fetchAllReviews called for announceId:", announceId);
    return this.api.simpleGet("reviews/all-reviews", announceId );
  }


  async fetchVisibleReviews(announceId: string, options: { signal?: AbortSignal } = {}) {
    return this.api.simpleGet("reviews/visible-reviews", announceId, options);
}

  // Toggle review visibility
  async updateReviewVisibility(reviewId: string, isVisible: boolean) {
    const params = { isVisible };
    return this.api.postById("reviews/visibility", reviewId, params);
  }

    // Fetch Announces from the same Hotel
    async GetAnnouncesByHotel(announceId: string) {
        //console.log("Fetching announces for announce ID:", announceId); // Debug log

        try {
            const response = await this.api.simpleGet("announces/hotel", announceId);
            //console.log("Response from API:", response); // Log the API response
            
            if (response.success) {
                //console.log("Fetched announces:", response.data); // Log the fetched data
                return response.data; // Return the data if successful
            } else {
                console.error("Error in API response:", response.message); // Log any error message
                throw new Error(response.message); // Throw an error to handle it upstream
            }
        } catch (error) {
            console.error('Error fetching announces from the same hotel:', error);
            throw new Error('Failed to fetch announcements from the same hotel.');
        }
    }

   

    async getRestaurantRank(announceId: string): Promise<{
        success: boolean;
        data?: {
          rank: number;
          total: number;
          city: string;
          debug?: any;
        };
        error?: string;
      }> {
        try {
          const response = await this.api.get(`announce/restaurant-rank/${announceId}`);
          
          // Ensure consistent response structure
          return {
            success: true,
            data: response.data
          };
        } catch (error) {
          console.error('Failed to fetch restaurant rank:', error);
          
          return {
            success: false,
            error: error instanceof Error ? error.message : 'Unknown error'
          };
        }
      }

}  
